/* eslint-disable i18next/no-literal-string */
import { ReactComponent as GoogleShape } from '../../../icons/google.svg';
import { ReactComponent as AppleShape } from '../../../icons/apple.svg';
import { trackStoreLinkClick } from '../tracking';

export const AndroidTVAppLink = () => (
  <a
    href="https://play.google.com/store/apps/details?id=no.vg.tv.android&hl=no"
    target="_blank"
    rel="noreferer nofollow"
    onClick={() => trackStoreLinkClick('vgtv-android-tv-app')}
  >
    <GoogleShape />
  </a>
);

export const AppleTVAppLink = () => (
  <a
    href="https://apps.apple.com/no/app/vgtv/id6717599497"
    target="_blank"
    rel="noreferer nofollow"
    onClick={() => trackStoreLinkClick('vgtv-apple-tv-app')}
  >
    <AppleShape />
  </a>
);

export const VGIOSAppLink = () => (
  <a
    href="https://apps.apple.com/no/app/vg/id381071021"
    target="_blank"
    rel="noreferrer nofollow"
    onClick={() => trackStoreLinkClick('vg-ios-app')}
  >
    <AppleShape />
  </a>
);

export const VGAndroidAppLink = () => (
  <a
    href="https://play.google.com/store/apps/details?id=com.agens.android.vgsnarvei&hl=no"
    target="_blank"
    rel="noreferrer nofollow"
    onClick={() => trackStoreLinkClick('vg-android-app')}
  >
    <GoogleShape />
  </a>
);

export const AirplayHelpLink = () => (
  <a
    href="https://support.apple.com/no-no/102661"
    target="_blank"
    rel="noreferrer nofollow"
  >
    Klikk her for mer informasjon om hvordan bruke Airplay
  </a>
);
